<template>
    <div class="clock-picker-global" :class="{mini:mini, isOpen:showPicker }">
        <!--<div class="clock-picker-button button default no-hover" @click="handlePicker">
            {{ selected.hour | two_digits }}:{{ selected.minute | two_digits }}
        </div>-->
        <input class="clock-picker-handler" :class="inputclass" ref="time" type="text" v-model="formatedSelected" v-inputmask="'99:99'" @click="handlePicker" @keyup="handleInput" @blur="handleBlur"/>
        <div class="clock-picker-container" :class="[constructPositionClasses,{show:showPicker}]" v-on-clickaway="unhandlePicker">
            <div class="hour-display">
                <span :class="{active:!showMinutes}" @click="handleHours">{{ selected.hour | two_digits }}</span>
                <span class="separator">:</span>
                <span :class="{active:showMinutes}" @click="handleMinutes">{{ selected.minute | two_digits }}</span>
                <i class="fa fa-eraser" v-if="nullable" @click="handleClear"></i>
            </div>
            <div class="clock-picker">

                <div class="clock-picker-hours-am" :class="{show:!showMinutes}">
                    <div v-for="i in range1" class="clock-picker-num"
                         :class="{'clock-picker-num-active':i == parseInt(selected.hour),'disabled':(i<minTime.hour || i>maxTime.hour)}" data-number="i"
                         @click.stop="selectHour(i)">{{ i }}
                    </div>
                    <div v-for="i in range2" class="clock-picker-num"
                         :class="{'clock-picker-num-active':i == parseInt(selected.hour),'disabled':(i<minTime.hour || i>maxTime.hour)}" data-number="i"
                         @click.stop="selectHour(i)">{{ i }}
                    </div>
                    <div class="clock-picker-hands">
                        <div class="clock-picker-hand"></div>
                    </div>
                </div>
                <div class="clock-picker-hours-pm" :class="{show:!showMinutes}">
                    <div v-for="i in range3" class="clock-picker-num"
                         :class="{'clock-picker-num-active':i == parseInt(selected.hour),'disabled':(i<minTime.hour || i>maxTime.hour)}" data-number="i"
                         @click.stop="selectHour(i)">{{ i }}
                    </div>
                    <div class="clock-picker-num"
                         :class="{'clock-picker-num-active':0 == parseInt(selected.hour),'disabled':(0<minTime.hour || 0>maxTime.hour)}" data-number="0"
                         @click.stop="selectHour(0)">0
                    </div>
                    <div v-for="i in range4" class="clock-picker-num"
                         :class="{'clock-picker-num-active':i == parseInt(selected.hour),'disabled':(i<minTime.hour || i>maxTime.hour)}" data-number="i"
                         @click.stop="selectHour(i)">{{ i }}
                    </div>
                    <div class="clock-picker-hands">
                        <div class="clock-picker-hand"></div>
                    </div>
                </div>
                <div class="clock-picker-minutes" :class="{show:showMinutes}">
                    <div v-for="i in rangeMin1" class="clock-picker-num"
                         :class="{'clock-picker-num-active':i == parseInt(selected.minute),'disabled':(i<minTime.minute || i>maxTime.minute)}" data-number="i"
                         @click.stop="selectMinute(i)">{{ i
                        }}
                    </div>
                    <div v-for="i in rangeMin2" class="clock-picker-num"
                         :class="{'clock-picker-num-active':i == parseInt(selected.minute),'disabled':(i<minTime.minute || i>maxTime.minute)}" data-number="i"
                         @click.stop="selectMinute(i)">{{ i
                        }}
                    </div>
                    <div class="clock-picker-hands">
                        <div class="clock-picker-hand"></div>
                    </div>
                </div>
            </div>
            <Btn v-if="mini" class="block primary reverse" @click.native.stop="validTime"><i class="fa fa-check"></i></Btn>
        </div>
    </div>

</template>


<script>
    import range from 'lodash/range';
    import Vue from 'vue';
    import moment from 'moment';
    import Btn from '@/components/ui/Button';
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Btn
        },
        computed: {
            range1: function () {
                return range(3, 13, 1)
            },
            range2: function () {
                return range(1, 3, 1)
            },
            range3: function () {
                return range(15, 24, 1)
            },
            range4: function () {
                return range(13, 15, 1)
            },
            rangeMin1: function () {
                return range(15, 60, 5)
            },
            rangeMin2: function () {
                return range(0, 15, 5)
            },
            formatedSelected: function(){
                return this.selected.hour+':'+this.selected.minute;
            },
            constructPositionClasses: function(){
                if(this.position.v != 'top' && this.position.v != 'bottom'){
                    this.position.v = 'top';
                }
                if(this.position.h != 'left' && this.position.h != 'right' && this.position.h != 'center'){
                    this.position.h = 'right';
                }
                return 'vpos-'+this.position.v+' hpos-'+this.position.h;
            }
        },
        created: function () {

        },
        data () {
            return {
                selected: {
                    hour: '',
                    minute: ''
                },
                showMinutes: false,
                showPicker: false,
                minTime: {
                    hour: 0,
                    minute: 0
                },
                maxTime: {
                    hour: 23,
                    minute: 59
                },
                firstTime: true

            }
        },
        destroyed: function () {

        },
        methods: {
            selectHour: function (hour) {
                if(this.nullable === true && hour == '' && this.selected.minute == ''){
                    this.$emit('input', null);
                    return;
                }
                if(hour>=this.minTime.hour && hour<=this.maxTime.hour){
                    this.selected.hour = hour;
                    this.showMinutes = true;
                    var time = Vue.filter('two_digits')(parseInt(this.selected.hour)) + ':' + Vue.filter('two_digits')(parseInt(this.selected.minute));
                    if(!this.mini){
                        this.$emit('input', time);
                    }

                }
            },
            selectMinute: function (minute) {
                if(this.nullable === true && this.selected.hour == '' && minute == ''){
                    this.$emit('input', null);
                    return;
                }
                if(minute>=this.minTime.minute && minute<=this.maxTime.minute) {
                    this.selected.minute = minute;

                    var time = Vue.filter('two_digits')(parseInt(this.selected.hour)) + ':' + Vue.filter('two_digits')(parseInt(this.selected.minute));
                    if(!this.mini){
                        this.showPicker = false;
                        this.$emit('input', time);
                    }
                }
            },
            validTime: function(){
                var time = Vue.filter('two_digits')(parseInt(this.selected.hour)) + ':' + Vue.filter('two_digits')(parseInt(this.selected.minute));
                this.$emit('input', time);
            },
            handleHours: function () {
                this.showMinutes = false;
            },
            handleMinutes: function () {
                this.showMinutes = true;
            },
            handlePicker: function () {
                this.$refs.time.select();
                this.showPicker = true;
                this.firstTime = true;
            },
            unhandlePicker: function () {

                if(!this.firstTime){
                    this.showPicker = false;
                }
                this.firstTime = false;
            },
            handleInput: function(){
                if(this.$refs.time.value.indexOf('_') == -1){
                    var time = this.$refs.time.value;
                    var temp = time.split(':');
                    if(temp[0] > 23){
                        this.selected.hour = 23;
                    }
                    else{
                        this.selected.hour = temp[0];
                    }

                    if(temp[1] > 59){
                        this.selected.minute = 59;
                    }
                    else{
                        this.selected.minute = temp[1];
                    }

                }
                else{
                    if(this.nullable === true){
                        this.selected.hour = '';
                        this.selected.minute = '';
                    }
                }


            },
            handleBlur: function(){
                if(this.nullable === true && this.selected.hour == '' && this.selected.minute == ''){
                    this.$emit('input', null);
                }
                else{

                    var time = Vue.filter('two_digits')(parseInt(this.selected.hour)) + ':' + Vue.filter('two_digits')(parseInt(this.selected.minute));
                    if(!this.mini){
                        this.$emit('input', time);
                    }

                }

            },
            handleClear: function(){
                this.selected.hour = '';
                this.selected.minute = '';
                this.$emit('input', null);
            },
            initSelected: function(value){
                if (value != null) {
                    var temp = value.split(':');
                    this.selected.hour = temp[0];
                    this.selected.minute = temp[1];
                }
                else{
                    if(this.nullable !== true){
                        var now = moment().format('HH:mm');
                        var temp = now.split(':');
                        this.selected.hour = temp[0];
                        this.selected.minute = temp[1];
                    }

                }
            },
            initMin: function(value){
                if (value != null) {
                    var temp = value.split(':');
                    this.minTime.hour = temp[0];
                    this.minTime.minute = temp[1];
                }
                else{
                    this.minTime.hour = 0;
                    this.minTime.minute = 0;
                }
            },
            initMax: function(value){
                if (value != null) {
                    var temp = value.split(':');
                    this.maxTime.hour = temp[0];
                    this.maxTime.minute = temp[1];
                }
                else{
                    this.maxTime.hour = 23;
                    this.maxTime.minute = 59;
                }
            },

        },
        mixins: [clickaway],
        mounted: function () {
            var val = '';
            if(this.value){
                val = this.value.toString();
            }
            this.initSelected(val);
            this.initMin(this.min);
            this.initMax(this.max);
        },
        name: '',
        props: {
            value: {
                type: String,
                default: ''
            },
            min: {
                type: String,
                default: "00:00"
            },
            max: {
                type: String,
                default: "23:59"
            },
            inputclass: {
                type: String,
                default: ''
            },
            mini: {
                type: Boolean,
                default: false
            },
            nullable: {
                type: Boolean,
                default: false
            },
            position: {
                type: Object,
                default: function(){
                    return {
                        v: 'top',
                        h: 'left'
                    }
                }
            }
        },
        updated: function () {

        },
        watch: {
            value: function (newValue) {
                if(newValue != null){
                    this.initSelected(newValue.toString());
                }
                else{
                    this.initSelected(':');
                }
            },
            min: function(newValue){
                this.initMin(newValue);
            },
            max: function(newValue){
                this.initMax(newValue);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>